import React from 'react';

const LoadingPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.9)), url("/bg.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      <img src="/LOGO_ALICE-01.png" alt="Loading..." width={'200rem'}/>
    </div>
  );
};

export default LoadingPage;